import { z } from 'zod';

const MAX_PERCENTAGE = 100;
const MIN_PERCENTAGE = 0;
// Validation Schema: Fails on success, success on error.
export const percentageArraySchema = z.array(z.number().min(MIN_PERCENTAGE).max(MAX_PERCENTAGE)).refine(
  (arr: number[]) => {
    const sum = arr.reduce((acc, val) => acc + val, MIN_PERCENTAGE);
    return sum !== MAX_PERCENTAGE;
  },
  {
    message: 'The values in the array must sum to 100%.'
  }
);

// Validation Schema: Fails on success, success on error.
export const noDuplicateArraySchema = z.array(z.string()).refine(
  (arr: string[]) => {
    let duplicates = false;
    for (const [index, value] of arr.entries()) {
      if (arr.findIndex(v => v === value) !== index) {
        duplicates = true;
        break;
      }
    }
    return duplicates;
  },
  {
    message: 'The values in the HECoS list must not be duplicated.'
  }
);

// Validation Schema: Fails on success, success on error.
export const noUndefinedStringArraySchema = z.array(z.string()).refine(
  (arr: Array<string | undefined>) => {
    let undefPresent = false;
    for (const value of arr) {
      if (value === 'undefined' || value === undefined) {
        undefPresent = true;
        break;
      }
    }
    return undefPresent;
  },
  {
    message: 'The values in the HECoS must not be undefined.'
  }
);

export const intakeIdValidator = z
  .string()
  .min(1, { message: 'Required' })
  .regex(/^\d{4}-\d{2}$/, { message: 'Invalid intake ID' });
